import Promise from 'promise';
import { firebaseDb } from '../../firebase';
import config from '../../config';

export const GET_FILES_LIST_REQUEST = 'GET_FILES_LIST_REQUEST';
export const GET_FILES_LIST_SUCCESS = 'GET_FILES_LIST_SUCCESS';
export const GET_FILES_LIST_FAILURE = 'GET_FILES_LIST_FAILURE';

export const GET_FILE_REQUEST = 'GET_FILE_REQUEST';
export const GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
export const GET_FILE_FAILURE = 'GET_FILE_FAILURE';

export const SEARCH_FILES_LIST_SUCCESS = 'SEARCH_FILES_LIST_SUCCESS';
export const SEARCH_FILES_DISABLE = 'SEARCH_FILES_DISABLE';
export const SEARCH_FILES_LIST_FETCHING = 'SEARCH_FILES_LIST_FETCHING';

export const GET_FILE_BY_PROJECT_REQUEST = 'GET_FILE_BY_PROJECT_REQUEST';
export const GET_FILE_BY_PROJECT_SUCCESS = 'GET_FILE_BY_PROJECT_SUCCESS';
export const GET_FILE_BY_PROJECT_FAILURE = 'GET_FILE_BY_PROJECT_FAILURE';

export const CLEAR_DETAIL_DATA = 'CLEAR_DETAIL_DATA';
export const CLEAR_PROJECT_FILES = 'CLEAR_PROJECT_FILES';

export const SET_FILTER = 'SET_FILTER';

export const getFilesByProjectIds = (projectIds) => dispatch => {
  dispatch({ type: GET_FILES_LIST_REQUEST });

  const promises = projectIds.map(
    projectId => firebaseDb.ref(`/project-files/${projectId}`).once('value')
  );

  let values = {};
  Promise.all(promises).then(results => {
    results.forEach(result => {
      values[result.key] = result.val();
    });

    dispatch({ type: GET_FILES_LIST_SUCCESS, payload: { files: values } });
  }).catch((result) => {
    dispatch({ type: GET_FILES_LIST_FAILURE, payload: result });
  });
};

export const getFile = (projectId, fileId) => dispatch => {
  firebaseDb.ref(`/project-files/${projectId}/${fileId}`).once('value', (snapshot) => {
    dispatch({ type: GET_FILE_SUCCESS, payload: snapshot.val() });
  })
};

export const searchFiles = (searchPhrase, projectIds) => dispatch => {
  const q = {
    "query": {
      "bool": {
        "must": [
          {
            "query_string": {
              "query": searchPhrase,
              "default_operator": 'AND'
            }
          },
          {
            "terms": {
              "project_id": projectIds
            }
          }
        ]
      }
    }
  };

  dispatch({ type: SEARCH_FILES_LIST_FETCHING });

  fetch(`${config.search.host}/search/file`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(q)
  }).then((response) => {
    return response.json ? response.json() : response;
  }).then((response) => {
    const files = response.hits.hits;
    let filesIds = [];
    files.map((file) => {
      filesIds.push(file._id);
    });

    dispatch({ type: SEARCH_FILES_LIST_SUCCESS, payload: filesIds });
  });

};

export const getFilesByProjectId = (projectId) => dispatch => {
  dispatch({ type: GET_FILE_BY_PROJECT_REQUEST });
  try {
    firebaseDb.ref(`/project-files/${projectId}`).once('value', (snapshot) => {
      dispatch({ type: GET_FILE_BY_PROJECT_SUCCESS, payload: snapshot.val(), projectId: projectId });
    })
  } catch (error) {
    dispatch({ type: GET_FILE_BY_PROJECT_FAILURE, payload: error });
  }
};

export const disableSearch = () => dispatch => {
  dispatch({ type: SEARCH_FILES_DISABLE });
};

export const clearFileDetails = () => dispatch => {
  dispatch({ type: CLEAR_DETAIL_DATA });
};

export const clearProjectFiles = () => dispatch => {
  dispatch({ type: CLEAR_PROJECT_FILES });
};

export const setFilter = (filter) => dispatch => {
  dispatch({ type: SET_FILTER, payload: filter });
};